package com.macrofocus.nastac.theme

import js.objects.unsafeJso
import mui.material.PaletteMode.Companion.dark
import mui.material.PaletteMode.Companion.light
import mui.material.styles.createTheme

object Themes {
    val Light = createTheme(
        unsafeJso {
            palette = unsafeJso {
                mode = light

                primary = unsafeJso {
                    // Header background color
//                    main = "#e65100"
                    main = "#1976d2" // Default
                }
                secondary = unsafeJso {
                    main = "#808080"
                }
                background = unsafeJso {
                    paper = "#ffffff"
                    // Content background color
                    default = "#ffffff"
//                    default = "#fafafa"
                }
            }
        }
    )

    val Dark = createTheme(
        unsafeJso {
            palette = unsafeJso {
                mode = dark

                primary = unsafeJso {
//                    main = "#ffcc80"
                    main = "#90caf9" // Default
                }
                secondary = unsafeJso {
                    main = "#ffffff"
                }
                background = unsafeJso {
                    // General background color
                    paper = "#000000" //"#182f3c" // "#303030"
                    // Content background color
                    default = "#323232" // "#0e2232" For e
                }
            }
        }
    )
}